module.exports = __webpack_public_path__ + "img/05-more-button.71344584.png";